import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-route',
  standalone: true,
  template: '', // No template needed as it will never be rendered
})
export class EmptyRouteComponent {}
